<i class="fa fa-search" ng-attr-title="{{'globalSearch.tooltip'|translate}}"></i>